import React from 'react';
import './About.css';
import team from "./team.png";
import Navbar2 from '../../Components/Navbar2';

function About() {
  return (
    <div className="about-page slide-in">
      <Navbar2 />
      <div className="about-header">
      <h1 className='heading-about'>Save time and get your contracts verified with <span className='highlight-about'> our AI based platform </span></h1>
      <p className='heading-about'>The simplest way to get your contracts verified? That’s us.</p>
      <img src={team} alt="Team working" className="team-image"/>
      <h1 className='heading-about'> <span className='highlight-about'>The reasons why we stand out </span></h1>
      <p className='heading-about'>A platform to empower blockchain while using business as a force for good.</p>
    </div>
    </div>
  );
}

export default About;
